import { render, staticRenderFns } from "./MainConfig.vue?vue&type=template&id=6c9fb612&"
import script from "./MainConfig.vue?vue&type=script&lang=js&"
export * from "./MainConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports